<template>
    <div class="bom-tab">
        <!-- 面料/里料清单 -->
        <div class="bom-section">
            <div class="bom-title-box">
                <span class="stick"></span>
                <span class="title">面料/里料清单：</span>
            </div>
            <table class="bom-table">
                <thead>
                    <tr>
                        <th>序号</th>
                        <th>产品信息</th>
                        <th>颜色</th>
                        <th>幅宽</th>
                        <th>克重</th>
                        <th>成分</th>
                        <th>供应商</th>
                        <th>耗量</th>
                        <th>单位</th>
                        <th>使用说明</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in (detail.material || [])" :key="item.id">
                        <td>
                            <div>
                                <div class="source-tag">平台</div>
                                <div>{{ item.alias }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="product-col">
                                <img :src="item.image" alt="产品" v-viewer/>
                                <div class="p-info">
                                    {{ item.fabric_name_cn }}
                                </div>
                            </div>
                        </td>
                        <td>{{ item.color_name_cn }}</td>
                        <td>{{ item.width_wide }}</td>
                        <td>{{ item.weight }}</td>
                        <td>{{ item.component }}</td>
                        <td>{{ item.supply && item.supply.company_name }}</td>
                        <td>{{ item.consumption }}</td>
                        <td>{{ item.unit }}</td>
                        <td>{{ item.desc }}</td>
                    </tr>
                    <template v-if="detail.is_material_self">
                      <tr
                        v-for="(item, index) in detail.material_self"
                        :key="'ms' + index"
                      >
                        <td>
                            <div>
                                <div class="source-tag">客供</div>
                                <div>{{ item.alias }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="product-col">
                                <img :src="item.image" alt="产品" v-viewer/>
                                <div class="p-info">
                                    {{ item.fabric_name_cn }}
                                </div>
                            </div>
                        </td>
                        <td>{{ item.color_name_cn }}</td>
                        <td>{{ item.width_wide }}</td>
                        <td>{{ item.weight }}</td>
                        <td>{{ item.component }}</td>
                        <td>{{ item.supply && item.supply.company_name }}</td>
                        <td>{{ item.consumption }}</td>
                        <td>{{ item.unit }}</td>
                        <td>{{ item.desc }}</td>
                      </tr>
                    </template>
                    <template v-if="detail.is_material_daigou">
                      <tr
                        v-for="(item, index) in detail.material_daigou"
                        :key="'md' + index"
                      >
                        <td>
                            <div>
                                <div class="source-tag">代购</div>
                                <div>{{ item.alias }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="product-col">
                                <img :src="item.image" alt="产品" v-viewer/>
                                <div class="p-info">
                                    {{ item.fabric_name_cn }}
                                </div>
                            </div>
                        </td>
                        <td>{{ item.color_name_cn }}</td>
                        <td>{{ item.width_wide }}</td>
                        <td>{{ item.weight }}</td>
                        <td>{{ item.component }}</td>
                        <td>{{ item.supply && item.supply.company_name }}</td>
                        <td>{{ item.consumption }}</td>
                        <td>{{ item.unit }}</td>
                        <td>{{ item.desc }}</td>
                      </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <!-- 辅料清单 -->
        <div class="bom-section">
            <div class="bom-title-box">
                <span class="stick"></span>
                <span class="title">辅料清单：</span>
            </div>
            <table class="bom-table">
                <thead>
                    <tr>
                        <th>来源</th>
                        <th>产品信息</th>
                        <th>颜色</th>
                        <th>供应商</th>
                        <th>单位</th>
                        <th>使用数量</th>
                        <th>使用说明</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in detail.accessory || []" :key="index">
                        <td>
                            <div class="source-tag">平台</div>
                        </td>
                        <td>
                            <div class="product-col">
                                <img :src="item.image" alt="辅料" v-viewer />
                                <div class="p-name">{{ item.accessory_name }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="color-col">
                                <img
                                    v-if="item.color_value"
                                    :src="item.color_value"
                                    v-viewer
                                />
                                <div class="color-name">{{ item.color_name_cn }}</div>
                            </div>
                        </td>
                        <td>{{ item.supplier }}</td>
                        <td>{{ item.measure_unit }}</td>
                        <td>{{ item.num }}</td>
                        <td>{{ item.desc }}</td>
                    </tr>
                    <template v-if="detail.is_accessory_self">
                      <tr
                        v-for="(item, index) in detail.accessory_self"
                        :key="`ass` + index"
                      >
                        <td>
                            <div class="source-tag">客供</div>
                        </td>
                        <td>
                            <div class="product-col">
                                <img :src="item.image" alt="辅料" v-viewer/>
                                <div class="p-name">{{ item.accessory_name }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="color-col">
                                <img
                                    v-if="item.color_value"
                                    :src="item.color_value"
                                    v-viewer
                                />
                                <div class="color-name">{{ item.color_name_cn }}</div>
                            </div>
                        </td>
                        <td>{{ item.supplier }}</td>
                        <td>{{ item.measure_unit }}</td>
                        <td>{{ item.num }}</td>
                        <td>{{ item.desc }}</td>
                      </tr>
                    </template>
                    <template v-if="detail.is_accessory_daigou">
                      <tr
                        v-for="(item, index) in detail.accessory_daigou"
                        :key="`asd` + index"
                      >
                        <td>
                            <div class="source-tag">代购</div>
                        </td>
                        <td>
                            <div class="product-col">
                                <img :src="item.image" alt="辅料" v-viewer />
                                <div class="p-name">{{ item.accessory_name }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="color-col">
                                <img
                                    v-if="item.color_value"
                                    :src="item.color_value"
                                    v-viewer
                                />
                                <div class="color-name">{{ item.color_name_cn }}</div>
                            </div>
                        </td>
                        <td>{{ item.supplier }}</td>
                        <td>{{ item.measure_unit }}</td>
                        <td>{{ item.num }}</td>
                        <td>{{ item.desc }}</td>
                      </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BomTab',
    props: {
        detail: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
        };
    }
};
</script>

<style lang="scss" scoped>
.bom-tab {
    font-size: 14px;
    line-height: 21px;
    .bom-section {
        margin-bottom: 24px;

        &:last-child {
            margin-bottom: 0;
        }

        .bom-title-box {
            display: flex;
            align-items: center;

            .stick {
                display: inline-block;
                width: 2px;
                height: 14px;
                background: #FF5967;
                border-radius: 4px;
                margin-right: 6px;
            }

            .title {
                font-weight: 500;
                color: #000000;
                text-align: left;
                font-style: normal;
                text-transform: none;
            }
        }

        .bom-table {
            margin-top: 12px;
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #e3e3e3;

            th,
            td {
                border-top: 1px solid #e3e3e3;
                border-bottom: 1px solid #e3e3e3;
                text-align: center;
                vertical-align: middle;
            }

            th {
                background: #F8F9FB;
                color: #666666;
                padding: 8px 8px;
            }

            td {
                color: #333333;
                padding: 12px 8px;

                .source-tag {
                    display: inline-block;
                    margin-bottom: 4px;
                    padding: 0px 4px;
                    border-radius: 2px;
                    background: #FF5967;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                }

                .product-col {
                    max-width: 200px;
                    display: flex;
                    align-items: center;
                    gap: 12px;

                    img {
                        width: 64px;
                        height: 64px;
                        object-fit: cover;
                        border-radius: 4px;
                        border: 1px solid #e3e3e3;
                    }
                    .p-info {
                        text-align: left;
                    }
                }
                .color-col {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    img {
                        width: 32px;
                        height: 32px;
                        border-radius: 2px;
                        border: 1px solid #e3e3e3;
                    }
                    .color-name {
                        text-align: left;
                    }
                }
            }
        }
    }
}
</style>